import {NgModule} from '@angular/core';
import {PulseParticipationComponent} from './pulse-participation.component';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {PulseParticipationOverallModule} from "../pulse-participation-overall/pulse-participation-overall.module";
import {PulseParticipationTrendModule} from "../pulse-participation-trend/pulse-participation-trend.module";
import { ParticipationHelpModule } from '../participation-help/participation-help.module';


@NgModule({ declarations: [PulseParticipationComponent],
    exports: [PulseParticipationComponent], imports: [BrowserModule,
        FormsModule,
        PulseParticipationOverallModule,
        PulseParticipationTrendModule,
        ParticipationHelpModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PulseParticipationModule {
}
